export default class ApiResponseService extends Error {
    constructor(response) {
        super();
        this.response = response;
        this.message = this.getMessage(response);
        this.name = this.constructor.name;
    }
    getMessage = (response) => {
        let message;
        switch (response.status) {
            case 400:
                switch (response.data.code) {
                    case 4: message = 'Parametros inválidos'; break;
                    case 8: message = 'Recurso no encontrado'; break;
                    case 10: message = "Archivo de consulta finalizado"; break;
                    case 13: message = "Error en la importación del excel"; break;
                    case 15: message = "El contrato se encuentra vencido"; break;
                    case 16: message = "El archivo no contiene todas las hojas requeridas en la respuesta"; break;
                    default: message = 'Código 400 no manejado, Contacte al administrador'; break;
                }
                break;
            case 401:
                switch (response.data.code) {
                    case 2: message = 'Autenticación fallida'; break;
                    default: message = 'Código 401 no manejado'; break;
                }
                break;
            case 403:
                switch (response.data.code) {
                    case 1: message = 'Email no se encuentra registrado en el sistema'; break;
                    case 3: message = 'Su cuenta se encuentra desactivada'; break;
                    case 9: message = 'Excede el maximo de consultas permitidas'; break;
                    case 11: message = 'Existen ruts duplicados'; break;
                    case 17: message = 'Archivo de consultas no finalizado'; break;
                    default: message = 'Código 403 no manejado, Contacte al administrador'; break;
                }
                break;
            case 404:
                switch (response.data.code) {
                    case 1: message = 'Email no se encuentra registrado en el sistema'; break;
                    case 14: message = 'Permiso denegado'; break;
                    default: message = 'Código 404 no manejado, Contacte al administrador'; break;
                }
                break;
            default:
                message = 'Error no manejado, Contacte al administrador';
                break;
        }
        return message;
    }
    getFields = () => {
        let fields = {};
        if (this.response.data && this.response.data.details) {
            fields = this.response.data.details;
        }

        return fields;
    }
}

